import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { Button, Row, Table, Divider, message, Input, Spin, Tag, Tooltip, Drawer } from 'antd';
import Title from 'antd/lib/typography/Title';
import { PopUpForm } from '../../../lib/ui/popupform';
import { Link } from 'react-router-dom';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../../lib/util';
import BatcherReconcilerList from './batcher_reconcilers_list';
import ErrorWrapper from '../../../lib/error_wrapper';
import { BasicHeader } from '../../../components/basic_header';
import { setting_quick_menu } from '../../../util/ui_util';
import { TransparentButton } from '../../../components/basic_items';
import { AddOutlined, SyncOutlined, WifiTetheringOutlined, StorageOutlined, Label, FlipOutlined } from '@material-ui/icons';
const queryString = require('query-string');

const group_fields = (group_id) => [
  {
    index: 'name',
    name: "Name",
    type: 'text',
  }
]

const type_fields = [
  {
    index: 'name',
    name: "Name",
    type: 'text'
  }
]

const group_cols = ({ onEditPressed, onDeletePressed, onExclusionPressed, onMoveToClicked }) => [
  { title: "Name", dataIndex: 'name', key: 'name',className:'bold-cell' },
  {
    title: "", dataIndex: "id", key: 'id', render: (id, data) => {
      return <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Button style={{
          padding: 0
        }} type='link' onClick={() => {
          typeof onEditPressed === 'function' && onEditPressed(data)
        }}>Edit</Button>
        <Divider type='vertical' />
        <Link to={`/settings/groups/batchers/${id}/rules`}>
          <Button style={{
            padding: 0
          }} type='link'>View</Button>
        </Link>
        <Divider type='vertical' />
        <Button type='link' style={{
          padding: 0
        }} onClick={() => {
          typeof onExclusionPressed === 'function' && onExclusionPressed(id)
        }}>Reconcilers</Button>
        {/* <Divider type='vertical' />
        <Button type='link' style={{
          padding: 0
        }} onClick={() => {
          typeof onMoveToClicked === 'function' && onMoveToClicked(id, data)
        }}>Move To</Button> */}
      </div>
    }
  }
]
class GroupBatcherList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      edit_id: null,
      form_data: {},
      schema: group_fields,
      form_visibility: false,
      filter_query: {},


      type_form_data: {},
      type_edit_id: null,
      type_form_visibility: false,

      selected_ids: [],
      all_selected: false,

      group_obj: {},
      loading: true,
      moving_id: null,
      move_data:{}
    }

    this.group_id = props.match.params.group_id;

    this.detail_group = RESTExecutor.detail().config({
      label: 'detail'
    }).callbacks((success) => {
      this.setState({ loading: false, group_obj: success.result })
      this.list_groups.config({
        params: {
          ...this.state.filter_query,
          group_id: this.group_id
        }
      }).execute();
    }, (error) => {
      this.setState({ loading: false })
    }).connect(props.domains.groups);



    this.list_groups = RESTExecutor.list().config({
      label: 'batcher_group_list',
      params: {
        per_page: 100
      }
    }).callbacks((success) => {

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.batchergroup);

    this.post_group = RESTExecutor.post().config({
      label: 'batcher_group_list'
    }).callbacks((success) => {
      message.success("Batcher Added");
      this.list_groups.execute();
      this.setState({
        edit_id: null,
        form_visibility: false,
        form_data: {}
      })
    }).connect(props.domains.batchergroup);

    this.patch_group = RESTExecutor.patch().config({
      label: 'batcher_group_detail'
    }).callbacks((success) => {
      message.success("Batcher Modified");
      this.list_groups.execute()
      this.setState({
        edit_id: null,
        form_visibility: false,
        form_data: {}
      })
    }).connect(props.domains.batchergroup);

   
    // this.export_data = RESTExecutor.post().config({
    //   label: 'export'
    // }).callbacks((success) => {
    //   this.setState({ selected_ids: [], all_selected: false })
    //   // console.log("download url",success)
    //   window.open(success.result.url, '_blank');

    // }, (error) => {
    //   showErrorInNotification(error)
    // }).connect(props.domains.settings);







    // this.list_datatype.execute();

    // this.list_groups.execute();

    this.delay_search = new NetworkDelaySearch();


  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  handlePostPatch = (data) => {
    console.log("object", Object.assign({ group_id: this.group_id }, data))
    if (this.state.edit_id) {
      this.patch_group.forId(this.state.edit_id).execute({
        ...data, group_id: this.group_id
      });
    } else {
      this.post_group.execute({
        ...data, group_id: this.group_id
      });
    }
  }

  render() {
    let list_group_resp = this.list_groups.response();


   

    let list_group_data = list_group_resp.result || {};
    let post_group_resp = this.post_group.response();
    let patch_group_resp = this.patch_group.response();

    let rowsData = list_group_data.rows || [];
    let rowsMeta = list_group_resp.meta || {};
    const { filter_query, selected_ids, loading, group_obj, moving_id } = this.state
    // let export_data_resp = this.export_data.response();
    let detail_group_resp = this.detail_group.response();

    if (loading) {
      return <center><Spin /></center>
    }

    return (
      <div>
        <ErrorWrapper error={detail_group_resp}
          onReload={() => {
            this.setState({ loading: true })
            this.detail_group.forId(this.group_id).execute();
          }}>


          <BasicHeader
            title={group_obj.name}
            titleType="Group"
            subtitle="Batchers"
            right={[
              <TransparentButton
                label="Add New"
                className='cta-primary'
                hint="Add New Batcher"
                onClick={() => {
                  this.setState({ form_data: {}, edit_id: null, form_visibility: true })
                }}

              />,
              <Link to={`/settings/groups/${this.group_id}/datatype`} >
                <TransparentButton
                  label="Datatypes"
                  icon={<StorageOutlined />}
                  hint="View Datatypes"
                />
              </Link>
              , <Link to={`/settings/groups/${this.group_id}/source`} >
                <TransparentButton
                  label="Sources"
                  icon={<WifiTetheringOutlined />}
                  hint="View Sources"
                />
              </Link>,
             <Link to={`/settings/groups/${this.group_id}/reconcilers`} >
             <TransparentButton
                 label="Reconcilers"
                 icon={<FlipOutlined />}
                 hint="View Reconcilers"
             />
         </Link>,
              <Link to={`/settings/groups/${this.group_id}/labels`} >
                <TransparentButton
                  label="Labels"
                  icon={<Label />}
                  hint="View Labels"
                /></Link>,

            //   <TransparentButton
            //     label="Export"
            //     hint="Export Selected Reconciler"
            //     disabled={selected_ids.length == 0}
            //     onClick={() => {
            //       this.export_data.execute({
            //         reconcilers: this.state.all_selected ? true : selected_ids
            //       });
            //     }}

            //   />
            ]}

          />

         
          <div className='filter-card'>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              flexWrap: 'nowrap',
              paddingTop: 4, paddingBottom: 12
            }}>
              <Input.Search
                placeholder="Search For"
                style={{
                }}
                allowClear
                autoFocus
                value={filter_query.query}
                onChange={(e) => {
                  this.stateUpdater({
                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value,
                    callback: () => {
                      this.delay_search.onSearch(() => {
                        this.props.history.push({
                          search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                        })
                      })
                    }
                  })
                }}
              />
            </div>
          </div>


          <ErrorWrapper
            error={list_group_resp}
            onReload={() => {
              this.list_groups.execute()
            }}
          >
            <div className='default-card' style={{
              padding: 0
            }}>
              <Table
                // rowClassName='hand-cursor'
                className='main-table'
                loading={list_group_resp.fetching}
                size='small'
                scroll={{ x: true }}
                rowSelection={{
                  onChange: (selected_ids) => {
                    if (selected_ids.length != rowsMeta.data_count) {
                      this.setState({ all_selected: false })
                    }
                    this.setState({ selected_ids })
                  },
                  selectedRowKeys: selected_ids
                }}
                pagination={{
                  simple: false,
                  position: 'bottom',
                  onChange: (current, size) => {
                    this.props.history.push({
                      search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                    })
                  },
                  defaultCurrent: 1,
                  current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                  pageSize: (rowsMeta && rowsMeta.requested_count),

                  total: (rowsMeta && rowsMeta.total_count),
                  showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                }}
                rowKey={(record) => record.id}
                columns={group_cols({
                  onEditPressed: (data) => {
                    this.setState({
                      form_data: data,
                      form_visibility: true,
                      edit_id: data.id
                    })
                  },
                  onExclusionPressed: (id) => {
                    this.setState({
                      exclusion_drawer_visibility: true,
                      current_recon_id: id
                    })
                  },
                  onMoveToClicked:(id,data)=>{
                    this.setState({
                      moving_id:id
                    })
                  }
                })}
                dataSource={rowsData}
              />
            </div>
          </ErrorWrapper>

          <PopUpForm
            title="Group Batcher"
            forCreate={this.state.edit_id
              ? false
              : true}
            initialData={this.state.form_data}
            fields={this.state.schema(this.group_id)}
            open={this.state.form_visibility}
            networkState={this.state.edit_id
              ? patch_group_resp
              : post_group_resp}
            onClose={() => {
              this.setState({ form_visibility: false, form_data: {}, edit_id: null })
            }}
            onSubmit={(data) => {
              console.log("data is", data)
              console.log("object1", Object.assign({ group_id: this.group_id }, data))
              console.log("object 1", { ...data, group_id: this.group_id })
              this.handlePostPatch(data);
            }} />

          <Drawer
            title={<Title style={{ margin: 0 }}>Batcher Reconcilers</Title>}
            placement="right"
            closable={true}
            width='50%'
            destroyOnClose
            onClose={() => {
              this.setState({
                exclusion_drawer_visibility: false,
                current_recon_id: null
              })
            }}
            visible={this.state.exclusion_drawer_visibility}
          >
            <BatcherReconcilerList
              // key={`-${this.state.current_recon_id}`}
              batcher_id={this.state.current_recon_id}
              group_id={this.group_id}
            />
          </Drawer>
        </ErrorWrapper>
      </div>
    );
  }

  componentDidMount() {
    overrideHeaderTitle("Reconcilers")
    overrideHeaderBack(null);

    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query,
        group_id: this.group_id
      }
    }, () => {
      this.detail_group.forId(this.group_id).execute()
    })

  }
  componentWillReceiveProps(nextProps) {
    var oldgroup_id = this.props.match.params.group_id;
    var newgroup_id = nextProps.match.params.group_id;


    if (oldgroup_id !== newgroup_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.group_id = newgroup_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed,
          group_id: this.group_id
        },
      }, () => {
        if (oldgroup_id !== newgroup_id) {
          this.setState({
            loading: true
          }, () => {
            this.detail_group.forId(this.group_id).execute();
          })
        } else {
          this.list_groups.forId(this.group_id).config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }
}

export default withDomains(GroupBatcherList, "batchergroup","groups");
